import React from "react";
import { inject, observer } from "mobx-react";
import GameInfoItem from "./gameInfoItem";
import agent from "../../agent";

import "./stylesheets/gameInfo.scss";

@inject("gameStore")
@observer
export default class GameInfo extends React.Component {
  intervalTag = null;

  state = {
    submissionRules: null,
    isReady: false,
    curTime: Date.now()
  };
  componentDidMount() {
    this.getSubmissionRulesFromServer(true);
    this.intervalTag = setInterval(this.getSubmissionRulesFromServer, 10 * 1000);
  }

  componentWillUnmount() {
    this.intervalTag && clearInterval(this.intervalTag);
  }

  // 获取当前赛事当前流程提交限制规则
  getSubmissionRulesFromServer = async isInit => {
    try {
      const res = await agent.SassPlatform.getSubmissionRules();
      const curlGameInfo = this.props.gameInfo;
      if (res && res.success && Array.isArray(res.data) && res.data.length > 0) {
        const curEventRules = res.data.find(
          item => item.eventId === curlGameInfo.eventId && item.flowId === curlGameInfo.id
        );
        curEventRules &&
          this.setState({
            submissionRules: curEventRules,
            curTime: res.timestamp
          });
      }
    } catch (error) {
      console.error(error);
    }
    if (isInit) {
      this.setState({
        isReady: true
      });
    }
  };

  render() {
    if (!this.state.isReady) return null;
    const gameInfo = this.props.gameInfo;
    const stages = gameInfo && gameInfo.stages && gameInfo.stages.nodes;
    let myIndex = -1;
    // 有提交限制的环节id
    const hasSubmissionLimitStageId = this.state.submissionRules
      ? this.state.submissionRules.stageId
      : null;
    const limitedNums = this.state.submissionRules ? this.state.submissionRules.max : null;
    const curTime = this.state.curTime;
    return (
      <div className="game-info">
        {stages &&
          stages.length > 0 &&
          stages.map((stage, index) => {
            // 过滤虚拟节点信息
            if (stage.isVirtual) {
              // 是虚拟节点信息
              return null;
            }
            myIndex += 1;

            return (
              <GameInfoItem
                gameType={this.props.gameType}
                canSubmit={this.props.canSubmit}
                stageIdMajorNum={this.props.stageIdMajorNum}
                myFlow={gameInfo}
                stageId={this.props.stageId}
                // 当前环节是否有提交限制（来自服务端）
                limited={stage.id === hasSubmissionLimitStageId}
                // 当前环节的每次提交限制次数
                limitedNums={limitedNums}
                // 服务端时间，防止用户更改本机时间
                curTime={curTime}
                gameData={this.props.gameData}
                index={myIndex}
                key={stage.id}
                node={stage}
              ></GameInfoItem>
            );
          })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/game/gameInfo.js